import { ICore } from "../apiClient/interfaces";
import { useQuery } from "@tanstack/react-query";
import { getCoreApiClientFunctions } from "../apiClient";

export function useStudentMe(
  token?: string,
  apiRole?: string,
): {
  studentExtended?: ICore.IStudentV4;
  studentExtendedLoading: boolean;
  studentExtendedRefreshing: boolean;
  studentExtendedError: any;
  refreshStudentExtended: any;
} {
  const clientFunc = getCoreApiClientFunctions({
    token: token,
  });
  const shouldFetch = !!token && apiRole == "student";

  const { data, error, isLoading, isRefetching, refetch } = useQuery({
    queryKey: ["student me", token],
    queryFn: () => clientFunc.getStudentMe(),
    enabled: shouldFetch,
  });

  return {
    studentExtended: data,
    studentExtendedLoading: isLoading,
    studentExtendedRefreshing: isRefetching,
    studentExtendedError: error,
    refreshStudentExtended: refetch,
  };
}
